<template>
  <!-- 安全管理 - 实时状态 -->
  <div class="timestatus">
    <el-form class="bginput" label-width="6rem">
      <el-form-item label="摄像头">
        <!-- <el-input v-model="formData.confUrl" placeholder="请录入组态页面地址"></el-input> -->

        <el-select style="width: 100%;" v-model="formData.confUrl" placeholder="请选择">
          <el-option v-for="(item,i) in cameraList" :key="i" :label="item.name" :value="item.indexCode"></el-option>
        </el-select>


      </el-form-item>
    </el-form>
    <div style="margin-top: 2rem;">
      <el-button @click="save" size="small" type="primary">保存设置</el-button>
    </div>
  </div>
</template>

<script>
import camera from '@/apis/safety/camera'

import api from '@/apis/safety/timestatus'
export default {
  data() {
    return {
      formData: {
        confUrl: '',
      },
      cameraList: [],

    }
  },
  mounted() {
    api
      .list({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            this.formData = res.data.list[0]
          }
        } else {
          this.$message.error(res.message)
        }
      })



    camera
      .cameraSearch({
        params: {
          pageNo: 1,
          pageSize: 1000,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          this.cameraList = res.data.data.list
        } else {
          this.$message.warning(res.message)
        }
      })


  },
  methods: {
    save() {

      api.save(this.formData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>

<style lang="less">
.timestatus { padding-top: 10px;
  width: 60%;
}
</style>